import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const SUSCRIPCIONES_CONST = 'suscripciones';

export const allSuscripcionesService = async (params) => {
  const res = await axios.get(`${baseUrl}/${SUSCRIPCIONES_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveSuscripcionesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${baseUrl}/${SUSCRIPCIONES_CONST}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(`${baseUrl}/${SUSCRIPCIONES_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneSuscripcionesService = async (id) => {
  const res = await axios.get(`${baseUrl}/${SUSCRIPCIONES_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteSuscripcionesService = async (id) => {
  const res = await axios.delete(`${baseUrl}/${SUSCRIPCIONES_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};
